<form class="row" [formGroup]="form">
    <div class="col-12">
        @if (prgId === null) {
            <ui-form-select
                [label]="'global.labels.partner' | translate"
                [formControlName]="programNumberOfTripsFormField.OrgId"
                [bindLabel]="'orgName'"
                [bindValue]="'orgId'"
                [clearable]="false"
                [options]="partners" />
        } @else {
            <div class="col-12">
                <ui-form-group-wrapper [label]="'global.labels.partner' | translate" [marginClass]="'mb-5'">
                    <div class="w-100">
                        <span class="form-control__static-value">{{ prtName }}</span>
                    </div>
                </ui-form-group-wrapper>
            </div>
        }

        <ui-form-input [label]="'global.forms.labels.name' | translate" [formControlName]="programNumberOfTripsFormField.Name" />
    </div>
    @if (prgId === null) {
        <div class="col-12">
            <ui-form-group-wrapper [label]="'global.forms.labels.service' | translate" [required]="true">
                <ng-select
                    bindLabel="srvName"
                    bindValue="srvId"
                    [clearAllText]="'global.actions.clear' | translate"
                    [notFoundText]="'global.labels.no_items_found' | translate"
                    [readonly]="lyView"
                    [items]="services"
                    [searchable]="false"
                    [clearable]="false"
                    [ngClass]="'ng-select--form-control'"
                    (change)="handlerChangeService($event)" />
            </ui-form-group-wrapper>
        </div>
    }

    <div class="col-12">
        <ui-form-group-wrapper [label]="'global.forms.labels.prgType' | translate" [marginClass]="'mb-5'">
            <div class="w-100">
                @if (prgTypeValue === b2bProgramTypeEnum.NumberOfTrips) {
                    <span class="form-control__static-value">{{ 'b2b.data.programType.1' | translate }}</span>
                } @else {
                    <span class="form-control__static-value">{{ 'b2b.data.programType.0' | translate }}</span>
                }
            </div>
        </ui-form-group-wrapper>
    </div>

    @if (prgId === null) {
        <div class="col-12">
            <ui-form-select
                [label]="(prgTypeValue === b2bProgramTypeEnum.NumberOfTrips ? 'global.labels.tickets' : 'global.labels.ticket') | translate"
                [formControlName]="programNumberOfTripsFormField.TrfIdArr"
                [bindLabel]="'trfName'"
                [bindValue]="'trfId'"
                [multiple]="true"
                [clearable]="false"
                [options]="tickets" />
        </div>
    } @else {
        <div class="col-12">
            <ui-form-group-wrapper
                [label]="(prgTypeValue === b2bProgramTypeEnum.NumberOfTrips ? 'global.labels.tickets' : 'global.labels.ticket') | translate"
                [marginClass]="'mb-5'">
                <div class="w-100">
                    <span class="form-control__static-value" [innerHTML]="trfName | parseB2bProgramTicketsName"></span>
                </div>
            </ui-form-group-wrapper>
        </div>
    }

    <ui-button-row [lyView]="lyView">
        @if (prgId === null) {
            <ui-button
                [size]="'lg'"
                [label]="'global.actions.add' | translate"
                [disabled]="form?.status === 'INVALID' || pending || !form.dirty"
                (handlerClick)="handlerAdd()" />
        } @else {
            <ui-button
                [size]="'lg'"
                [label]="'global.actions.save' | translate"
                [disabled]="form?.status === 'INVALID' || pending || !form.dirty"
                (handlerClick)="handlerEdit()" />
        }
    </ui-button-row>
</form>
